import React from 'react';
import { Palette, TreePine, UtensilsCrossed, BookOpen } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Facilities = () => {
  const facilities = [
    {
      id: 1,
      title: "Salas Coloridas",
      description: "Ambientes temáticos por faixa etária, com mobiliário adequado e materiais pedagógicos",
      icon: Palette,
      color: 'from-red-400 to-pink-500'
    },
    {
      id: 2,
      title: "Área Externa Segura",
      description: "Espaço amplo para brincadeiras e desenvolvimento motor com segurança total",
      icon: TreePine,
      color: 'from-green-400 to-emerald-500'
    },
    {
      id: 3,
      title: "Refeitório",
      description: "Alimentação balanceada e nutritiva preparada com carinho",
      icon: UtensilsCrossed,
      color: 'from-blue-400 to-indigo-500'
    },
    {
      id: 4,
      title: "Biblioteca Infantil",
      description: "Cantinho da leitura com livros infantis para estimular a imaginação",
      icon: BookOpen,
      color: 'from-purple-400 to-pink-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-amber-50/50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
              Nossa Estrutura
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Ambientes Pensados com Carinho
          </h2>
          <p className="text-lg text-gray-600">
            Espaços seguros, acolhedores e estimulantes para o desenvolvimento pleno das crianças
          </p>
        </div>

        {/* Facilities Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {facilities.map((facility) => {
            const IconComponent = facility.icon;
            
            return (
              <Card 
                key={facility.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-amber-200 bg-white"
              >
                <CardContent className="p-6 text-center">
                  {/* Icon */}
                  <div className="relative inline-block mb-6">
                    <div className={`absolute inset-0 bg-gradient-to-br ${facility.color} rounded-2xl blur-lg opacity-40 group-hover:opacity-60 transition-opacity`}></div>
                    <div className={`relative bg-gradient-to-br ${facility.color} p-4 rounded-2xl shadow-lg group-hover:scale-110 transition-transform`}>
                      <IconComponent className="text-white" size={32} />
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-amber-600 transition-colors">
                    {facility.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {facility.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
